module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-mv-slider-arrows-icon-next-3133935f0cc2e98e0c3824038273cb58.svg";